"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var estate_1 = require("../../model/estate");
var service_1 = require("../../../library/base/service");
var List = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '房地产列表接口';
        _this.code = '101088';
        _this.desc = '房地产列表接口';
        _this.requestParams = new estate_1.ListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return List;
}(service_1.BaseService));
exports.List = List;
//# sourceMappingURL=list.js.map